"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopModifierKey = exports.ShopBrand = exports.SelectionKey = exports.OptionKey = exports.TypeKey = void 0;
var TypeKey;
(function (TypeKey) {
    TypeKey["subscription"] = "subscription";
    TypeKey["oneTime"] = "one-time";
})(TypeKey = exports.TypeKey || (exports.TypeKey = {}));
var OptionKey;
(function (OptionKey) {
    OptionKey["gummy"] = "gummy";
    OptionKey["capsule"] = "capsule";
    OptionKey["other"] = "other";
    OptionKey["bundle"] = "bundle";
})(OptionKey = exports.OptionKey || (exports.OptionKey = {}));
var SelectionKey;
(function (SelectionKey) {
    SelectionKey["type"] = "type";
    SelectionKey["option"] = "option";
    SelectionKey["quantity"] = "quantity";
    SelectionKey["upsell"] = "upsell";
})(SelectionKey = exports.SelectionKey || (exports.SelectionKey = {}));
// Enum for Shop Section branding with CSS color 
// NOTE:
// - this enum should be synced with collection metafield "shop_brand"
// - this value should be ONLY used for CSS color theme
// - if you intend to customize shop section for only specific products,
//   use "shop_modifier" metafield in collection (defined and explained below).
// - WHY? because some products share the same brand but render different 
//   shop sections. E.g., URO UT & Sex collection are both "uro-vp" brand 
var ShopBrand;
(function (ShopBrand) {
    ShopBrand["floPms"] = "flo-pms";
    ShopBrand["floOs"] = "flo-os";
    ShopBrand["gogo"] = "gogo";
    ShopBrand["moto"] = "moto";
    ShopBrand["uroUt"] = "uro-ut";
    ShopBrand["uroVp"] = "uro-vp";
    ShopBrand["uroBs"] = "uro-bs";
    ShopBrand["disco"] = "disco";
    ShopBrand["meno"] = "meno";
    ShopBrand["retroGs"] = "retro-gs";
    ShopBrand["retroAcne"] = "retro-acne";
    ShopBrand["willo"] = "willo";
    ShopBrand["default"] = "default";
})(ShopBrand = exports.ShopBrand || (exports.ShopBrand = {}));
// Enum for Shop Section modifier 
// NOTE: 
// - this enum should be synced with the metaobject "shop_modifier"
// - url: https://admin.shopify.com/store/o-positiv/settings/custom_data/metaobjects/shop_modifier
// - if you intend to customize shop section for only specific products,
//   use this metafield instead of "shop_brand" metafield above.
// - expand this enum & metaobject definition when shop section modification test wins,
//   but not deployed to the whole shop section
var ShopModifierKey;
(function (ShopModifierKey) {
    ShopModifierKey["sellingFast"] = "selling_fast";
    ShopModifierKey["savePercentage"] = "save_percentage";
    ShopModifierKey["subscriptionText"] = "subscription_text";
    ShopModifierKey["showDualUpsell"] = "show_dual_upsell";
})(ShopModifierKey = exports.ShopModifierKey || (exports.ShopModifierKey = {}));
